<script setup lang="ts">
import LocalLoader from "@/components/ui/loaders/LocalLoader.vue";

interface Props {
  position?: "fixed" | "absolute";
}

const props = withDefaults(defineProps<Props>(), {
  position: "fixed",
});
</script>

<template>
  <div
    class="table-loader"
    :class="`table-loader--${props.position}`"
  >
    <LocalLoader />
  </div>
</template>

<style scoped lang="scss">
.table-loader {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  background-color: var(--background-bg-white);

  &--fixed {
    position: fixed;
  }

  &--absolute {
    position: absolute;
  }
}
</style>